import EmptyStateBackgroundImage from '@assets/images/empty-state_background-fade-light.png';
import {Illustrations} from './types';

const illustrations = {
    EmptyStateBackgroundImage,
} satisfies Illustrations;

export default illustrations;
